import Vue from 'vue'

let searchBus = new Vue({name: 'searchBus'})

searchBus.actions = {
  KEY_DOWN: 'KEY_DOWN',
  KEY_UP: 'KEY_UP',
  KEY_ENTER: 'KEY_ENTER',
  KEY_ESCAPE: 'KEY_ESCAPE'
}
export default searchBus



// WEBPACK FOOTER //
// ./src/components/shared/SearchBus.js